module.exports = __webpack_public_path__ + "static/media/crown.b2bc4c74.png";